import styled from '@emotion/styled';
import { Caption } from 'app/components/Typography/Caption';

export const Description = styled(Caption)`
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0.005em;
  text-align: left;
  color: rgba(137, 145, 160, 1);
  padding-left: 20px;
`;

export const Label = styled.p`
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.03em;
  text-align: left;
  color: rgba(35, 43, 58, 1);
  height: auto;
  margin-bottom: 8px;
`;
